import * as React from 'react';
import { InfoWindow, Marker } from "react-google-maps";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as DTOS from "../../../../../../FeralScan.dtos";
import * as DashboardActionCreators from "../../../../../../actions/dashboard.actions";
import * as DataActionCreators from "../../../../../../actions/data.actions";
import * as MapActionCreators from "../../../../../../actions/map.actions";
import * as FilterActionCreators from "../../../../../../actions/filter.actions";
import { IAppState } from '../../../../../../app';
import { ITab } from '../../../../../../configuration/ICustomConfiguration';
import { MapState, MapType, LatLong } from '../../../../../../reducers/map.reducer';
import PlotEdit from '../../../../../Data/Plot/PlotEdit';
import MapContainer from '../../../../../Map/MapContainer';
import { MarkerIcon } from '../../../../../Map/Platypus/MapMarker';
import PlotSummary from '../../../../../Map/Platypus/PlotSummary';
import { IBasePageProps, PlatypusPlotStatus } from '../../../../configuration/IConfiguration';
import { FilterState } from '../../../../../../reducers/filter.reducer';
import { IClassificationSelectOption } from '../../../../../Common/ClassificationSelect';
import InternalClassificationLink from '../../../../Common/Links/InternalClassificationLink';


type PageFindingsProps = {
    defaultMarkerIcon: MarkerIcon;
    mapType: MapType;
    mapGridSize: number;
    mapGoogleMapURL: string;
    mapMarkerComponent: any;
    mapMarkerOutlineColour: string;
}

type PageFindingsActions = {
}

type PageFindingsRouteParams = {
}

type PageFindingsQueryParams = {
}

type PageFindingsPropsMapped = {
    map: MapState;
    plotSummaryData: DTOS.PlotSummary[];
    plots: DTOS.Plot[];
    userPlots: DTOS.Plot[];
    filter: FilterState;
}

type PageFindingsActionsMapped = {
    flagPlot: typeof DashboardActionCreators.flagPlotRequest;
    getPlotSummaryData: typeof DataActionCreators.getPlotSummaryDataRequest;
    getPlots: typeof DataActionCreators.getPlotsRequest;
    onCreatePlot: typeof DashboardActionCreators.createPlotRequest;
    toggleMarkerPopup: typeof MapActionCreators.toggleMarkerPopupRequest;
    toggleNewMarkerPopup: typeof MapActionCreators.toggleNewMarkerPopupRequest;
    updateFilters: typeof FilterActionCreators.applyFilter;
}

type PageFindingsAllPropsInherited = PageFindingsProps & PageFindingsActions;
type PageFindingsAllPropsMapped = PageFindingsPropsMapped & PageFindingsActionsMapped;

type PageFindingsAllProps = IBasePageProps<PageFindingsRouteParams, PageFindingsQueryParams> & Partial<PageFindingsAllPropsMapped> & PageFindingsAllPropsInherited;

class PageFindings extends React.Component<PageFindingsAllProps, any> {
    constructor(props, context) {
        super(props, context);

        this.generateDataMarkers = this.generateDataMarkers.bind(this);
        this.generateNewMarker = this.generateNewMarker.bind(this);
    }

    componentDidMount() {
        // this should all be refactored so we don't need to update filter on mount 
        // for mobile collapsed view which never mounts the form
        var newFilter: FilterState = { ...this.props.filter };

        const o: IClassificationSelectOption = {
            value: undefined,
            label: "All data"
        };

        newFilter.selectedClassifications = o;

        this.props.updateFilters(newFilter);
    }

    componentDidUpdate(prevProps: PageFindingsAllProps) {
        const { plots, filter } = this.props;

        if (plots && prevProps.plots != plots) {
            this.props.getPlotSummaryData(plots.map(p => p.id),
                filter.selectedClassifications ? filter.selectedClassifications.value : undefined,
                filter.startDate,
                filter.endDate
            );
        }

        if (filter && prevProps.filter != filter) {
            this.props.getPlots(undefined, undefined, filter.startDate, filter.endDate, [PlatypusPlotStatus.ACTIVE, PlatypusPlotStatus.INACTIVE, PlatypusPlotStatus.EVALUATING]);
        }
    }

    generateDataMarkers(plots: DTOS.Plot[], userPlots: DTOS.Plot[], openMarkers: any[], plotSummaryData: any) {
        let markers: JSX.Element[] = [];

        if (plots) {
            plots.forEach((p, i) => {
                // Total Abundance Count

                let icon: MarkerIcon = undefined; /*{
                    path: "M-20,0 a20,20 0 1,0 40,0 a20,20 0 1,0 -40,0",
                    fillColor: '#444044',
                    fillOpacity: 1,
                    anchor: { x: 0, y: 0 },
                    strokeWeight: 0,
                    scale: 1
                }*/

                let popup = <PlotSummary
                    children={InternalClassificationLink(`site/${p.id}`, 'VIEW DATA', undefined, `btn btn-sm btn-primary ml-auto`)}
                    dateFormat={this.props.defaultDateFormat}
                    plotSummary={undefined}
                    plot={p}
                    userMonitoring={userPlots && p && userPlots.some(p2 => p2.id == p.id)}

                    flagPlot={this.props.flagPlot}
                    toggleMarkerPopup={this.props.toggleMarkerPopup}
                />;

                const plotSummary: DTOS.PlotSummary = plotSummaryData && plotSummaryData[p.id] ? plotSummaryData[p.id].summaryData : undefined;
                if (plotSummary) {
                    const avgNumbers = plotSummary.primaryValue 
                        ? plotSummary.primaryValue.value / plotSummary.plotEventCount 
                        : -1;

                    icon = {...this.props.defaultMarkerIcon};

                    icon.strokeColor = this.props.mapMarkerOutlineColour;
                    icon.fillColor = avgNumbers >= .5 ?
                        '#444044' :
                        avgNumbers >= .1 ?
                            '#888488' :
                            '#CCC8CC';

                    popup = <PlotSummary
                        children={InternalClassificationLink(`site/${p.id}`, 'VIEW DATA', undefined, `btn btn-sm btn-primary ml-auto`)}
                        dateFormat={this.props.defaultDateFormat}
                        plotSummary={plotSummary}
                        plot={p}
                        userMonitoring={userPlots && p && userPlots.some(p2 => p2.id == p.id)}

                        flagPlot={this.props.flagPlot}
                        toggleMarkerPopup={this.props.toggleMarkerPopup}
                    />;
                }

                const marker = <this.props.mapMarkerComponent
                    key={`mapmarker-${p.id}`}
                    icon={icon}
                    id={p.id}
                    interactive={true}

                    popup={popup}
                    position={{ lat: p.latitude, lng: p.longitude }}
                    isOpen={openMarkers ? openMarkers.indexOf(p.id) > -1 : false}
                    toggleMarkerPopup={this.props.toggleMarkerPopup}
                >
                </this.props.mapMarkerComponent>

                markers.push(marker);
            });
        }

        return markers;
    }

    generateNewMarker(openNewMarker: LatLong) {
        let newMarkerIcon: MarkerIcon;
        let newMarkerPopup: JSX.Element;
        let newMarker: JSX.Element;

        if (openNewMarker) {
            newMarkerIcon = {
                anchor: { x: 15, y: 3 },
                path: "M15 3 Q16.5 6.8 25 18 A12.8 12.8 0 1 1 5 18 Q13.5 6.8 15 3z",

                fillColor: '#DC1E1E',
                fillOpacity: 1,
                rotation: 180,
                scale: 1.5,
                strokeWeight: 0
            };

            newMarkerPopup = <InfoWindow onCloseClick={this.props.toggleNewMarkerPopup.bind(this, undefined, undefined)}>
                <div style={{ /*marginLeft: "20px",*/ width: "325px" }}>
                    <PlotEdit
                        lat={openNewMarker.latitude}
                        lng={openNewMarker.longitude}
                        onCreatePlot={this.props.onCreatePlot}
                    />
                </div>
            </InfoWindow>;

            newMarker = <Marker
                position={{
                    lat: openNewMarker.latitude,
                    lng: openNewMarker.longitude
                }}
            //icon={newMarkerIcon}
            >
                {newMarkerPopup}
            </Marker>
        }

        return newMarker;
    }

    render() {

        const mockActiveTab: ITab = {
            mapTabSettings: {
                mapTypeId: "roadmap",
                mapEnablePlotCreation: false,
                showAddPlotEventButton: false,
                showMapOptions: false
            },
            bannerName: undefined,
            mapQueryStringToProps: undefined,
            needsAuthentication: undefined,
            pageTitle: undefined,
            pushIntoQueryString: undefined,
            route: undefined,
            shouldRerouteHome: undefined,
            showContentHeader: undefined,
            showFooter: undefined,
            showHeader: undefined,
            showSideBar: undefined,
            sidebarLink: undefined,
            type: undefined
        }

        const markers = this.generateDataMarkers(this.props.plots, this.props.userPlots, this.props.map.openMarkers, this.props.plotSummaryData);

        const newMarker = this.generateNewMarker(this.props.map.openNewMarker);

        return (
            <MapContainer
                activeTab={mockActiveTab}
                changeTab={undefined}
                googleMapURL={this.props.mapGoogleMapURL}
                gridSize={this.props.mapGridSize}
                mapType={this.props.mapType ? this.props.mapType : "normal"}
                markers={markers}
                newMarker={newMarker}
                //plots={this.props.plots}

                zoomInOnClick={false}
            />
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: PageFindingsAllProps): PageFindingsPropsMapped => {

    return {
        map: state.map,
        //plotSummaryData: state.data.plotSummaryData as DTOS.PlatypusPlotSummary[],
        //plotSummaryData: undefined,
        plotSummaryData: state.summaryData.plotSummaryData,
        plots: state.data.plots,
        userPlots: state.data.userPlots,
        filter: state.filter,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators<PageFindingsActionsMapped>({
        flagPlot: DashboardActionCreators.flagPlotRequest,
        getPlotSummaryData: DataActionCreators.getPlotSummaryDataRequest,
        getPlots: DataActionCreators.getPlotsRequest,
        onCreatePlot: DashboardActionCreators.createPlotRequest,
        toggleMarkerPopup: MapActionCreators.toggleMarkerPopupRequest,
        toggleNewMarkerPopup: MapActionCreators.toggleNewMarkerPopupRequest,
        updateFilters: FilterActionCreators.applyFilter,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)<PageFindingsAllPropsInherited>(PageFindings);